import { Form, Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { IoFilterSharp } from "react-icons/io5";
import * as yup from "yup";

import { LiaTimesSolid } from "react-icons/lia";
import { ERROR_MSG, ROLE } from "../../../constants/common";
import {
    RESET_LOADER,
    SET_ERROR,
    SET_LOADER,
} from "../../../constants/contexConstant";
import {
    GET_ADMIN_COMPLETED_PROJECTS,
    GET_ADMIN_ON_GOING_PROJECTS,
    GET_ADMIN_PROJECT_STATUS,
    GET_HYPERSROT_MEMBERS_API,
    GET_SALES_COMPLETED_PROJECTS,
    GET_SALES_ON_GOING_PROJECTS,
    GET_SALES_PROJECT_STATUS,
} from "../../../constants/routes";
import { useContextState } from "../../../context/ContextProvider";
import { checkIsAllowed } from "../../../helpers/helpers";
import cn from "../../../lib/cn";
import { statusImages } from "../../../resources/js/icons";
import request from "../../../services/request";
import Container from "../../../shared/Container";
import Section from "../../../shared/Section";
import P from "../../../shared/typography/P";
import Button from "../../../shared/ui/Button";
import CloseButton from "../../../shared/ui/CloseButton";
import BottomDrawer from "../../../shared/ui/Drawer/BottomDrawer";
import FormikLabeledInput from "../../../shared/ui/Form/FormikLabeledInput";
import LabeledFormikSelect from "../../../shared/ui/Form/LabeledFormikSelect";
import LinedTab from "../../../shared/ui/tab/LinedTab";
import ViewFollowUp from "../followup";
import AdminPaymentReceipt from "../payment";
import AdminProjectStage from "../stage";
import CompletedProjectCard from "./CompletedProjectCard";
import OngoingStatusCard from "./OngoingStatusCard";

const viewsTypes = {
    followup: "followup",
    stage: "stage",
    history: "history",
    main: "main",
};
let initialViews = {
    name: viewsTypes.main,
    data: null,
};

const filterButtonStyle =
    "bg-gray-200 px-1 py-0.2 text-sm rounded flex items-center gap-0.5";

const AdminProjectStatus = () => {
    const [currentTab, setCurrentTab] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const { state, dispatch } = useContextState();
    const [ongoingProject, setOngoingProject] = useState([]);
    const [completedProject, setCompletedProject] = useState([]);
    const [statusData, setStatusData] = useState({});

    const [view, setView] = useState(initialViews);

    let [assignees, setAssignees] = useState([]);

    const [filterOptions, setFilterOptions] = useState({
        duration: "",
        plantName: "",
        plantId: "",
        // assignee: "",
    });

    const isAdmin = checkIsAllowed(state?.user?.roles, [ROLE.SUPER_ADMIN]);
    const statusPath = isAdmin
        ? GET_ADMIN_PROJECT_STATUS
        : GET_SALES_PROJECT_STATUS;

    const onGoingPath = isAdmin
        ? GET_ADMIN_ON_GOING_PROJECTS
        : GET_SALES_ON_GOING_PROJECTS;

    const completedPath = isAdmin
        ? GET_ADMIN_COMPLETED_PROJECTS
        : GET_SALES_COMPLETED_PROJECTS;

    const getQueryParams = useCallback(
        (duration, plantName, plantId, assignee) => {
            let commonFilters =
                duration === filterOptions.duration &&
                plantName === filterOptions.plantName &&
                filterOptions.plantId === plantId;

            if (
                (isAdmin &&
                    commonFilters &&
                    filterOptions.assignee === assignee) ||
                commonFilters
            )
                return null;

            const queryParams = new URLSearchParams();
            if (duration) queryParams.append("duration", duration);
            if (plantId) queryParams.append("plantId", plantId);
            if (plantName) queryParams.append("plantName", plantName);
            // if (assignee) queryParams.append("assignee", assignee);

            return queryParams.toString() ? `?${queryParams.toString()}` : "";
        },
        [
            filterOptions.assignee,
            filterOptions.duration,
            filterOptions.plantId,
            filterOptions.plantName,
            isAdmin,
        ]
    );

    const getProjectsAllStats = useCallback(
        async (
            duration = null,
            plantName = null,
            plantId = null,
            assignee = null
        ) => {
            let queryString = getQueryParams(
                duration,
                plantName,
                plantId,
                assignee
            );
            if (!queryString) return;
            try {
                dispatch({ type: SET_LOADER });
                let res = await request.authGet({
                    endpoint: `${onGoingPath}${queryString}`,
                });
                setOngoingProject(res?.data?.projects);

                let resCompleted = await request.authGet({
                    endpoint: `${completedPath}${queryString}`,
                });
                setCompletedProject(resCompleted?.data?.projects);

                dispatch({ type: SET_LOADER });
                let resStatus = await request.authGet({
                    endpoint: `${statusPath}${
                        duration ? `?duration=${duration}` : ""
                    }`,
                });
                setStatusData(resStatus?.data?.data);

                dispatch({ type: RESET_LOADER });
            } catch (error) {
                dispatch({ type: RESET_LOADER });
                dispatch({
                    type: SET_ERROR,
                    payload: typeof error === "string" ? error : ERROR_MSG,
                });
            }
        },
        [completedPath, dispatch, getQueryParams, onGoingPath, statusPath]
    );

    useEffect(() => {
        const getMembers = async () => {
            try {
                dispatch({ type: SET_LOADER });
                let res = await request.authGet({
                    endpoint: GET_HYPERSROT_MEMBERS_API,
                });
                let response = res?.data?.members;
                if (response) {
                    setAssignees(
                        response.map((item) => ({
                            label: item.name,
                            value: item.name,
                        }))
                    );
                }
                dispatch({ type: RESET_LOADER });
            } catch (error) {
                dispatch({ type: RESET_LOADER });
                dispatch({
                    type: SET_ERROR,
                    payload: typeof error === "string" ? error : ERROR_MSG,
                });
            }
        };

        if (checkIsAllowed(state?.user?.roles, [ROLE.SUPER_ADMIN])) {
            getMembers();
        }
    }, [dispatch, state?.user?.roles]);

    useEffect(() => {
        getProjectsAllStats();
    }, []);

    const handleTabClick = (val) => {
        setCurrentTab(val);
    };

    const handleSubmit = (values, actions) => {
        setIsOpen(false);
        setFilterOptions(values);

        getProjectsAllStats(
            values.duration,
            values.plantName,
            values.plantId,
            values.assignee
        );
    };
    const handleResetView = () => {
        setView(initialViews);
    };

    const clearFilters = (key) => {
        let existingFilter = { ...filterOptions };
        existingFilter[key] = "";
        setFilterOptions(existingFilter);
        getProjectsAllStats(
            existingFilter.duration,
            existingFilter.plantName,
            existingFilter.plantId
            // values.assignee
        );
    };

    return (
        <>
            <div className="lg:hidden">
                <div
                    className={cn("mb-0 hidden ", {
                        block: view.name === viewsTypes.stage,
                    })}
                >
                    <AdminProjectStage
                        plantId={view.data}
                        onClick={handleResetView}
                    />
                </div>

                <div
                    className={cn("mb-0 hidden", {
                        block: view.name === viewsTypes.followup,
                    })}
                >
                    <ViewFollowUp data={view.data} onClick={handleResetView} />
                </div>
                <div
                    className={cn("mb-0 hidden", {
                        block: view.name === viewsTypes.history,
                    })}
                >
                    <AdminPaymentReceipt onClick={handleResetView} />
                </div>
            </div>

            <Section
                className={cn("mb-0 hidden lg:block lg:mt-5 ", {
                    block: view.name === viewsTypes.main,
                })}
            >
                <div className="lg:container lg:flex  lg:pt-12 gap-2.4">
                    <div className="lg:shadow-2xl lg:rounded-2  lg:w-4/12 lg:bg-white">
                        <div className=" bg-blue-700 pt-12 pb-6 lg:bg-white lg:pt-0 lg:pb-0 ">
                            <Container className="lg:px-1.5 lg:pt-1.5 lg:rounded-2">
                                <div className="rounded-2 p-1.6 bg-blue-550 lg:bg-linear-blue-white-v3  ">
                                    <div className="py-0.8 rounded-sm bg-blue-700 mb-2 font-vietnam lg:bg-white ">
                                        <P className="text-center text-white  text-sm lg:text-primary">
                                            {filterOptions.duration ===
                                            "lifetime"
                                                ? "Lifetime Status"
                                                : filterOptions.duration ===
                                                  "30D"
                                                ? "Last One Month"
                                                : filterOptions.duration ===
                                                  "365D"
                                                ? "Last 1 Year"
                                                : "Last 1 Week"}
                                        </P>
                                    </div>

                                    <div className="flex justify-between items-center mb-2 font-vietnam">
                                        <div className="text-center ">
                                            <P className="text-sm font-medium text-white">
                                                {statusData?.totalLeads || 0}
                                            </P>
                                            <P className="text-xs text-white">
                                                Total Lead
                                            </P>
                                        </div>
                                        <div className="w-0.1 bg-white h-auto"></div>{" "}
                                        <div className="text-center">
                                            <P className="text-sm font-medium text-white">
                                                {statusData?.freshLeads || 0}
                                            </P>
                                            <P className="text-xs text-white">
                                                Fresh Lead Lead
                                            </P>
                                        </div>
                                        <div className="w-0.1 bg-white h-auto "></div>{" "}
                                        <div className="text-center ">
                                            <P className="text-sm font-medium text-white">
                                                {statusData?.followups || 0}
                                            </P>
                                            <P className="text-xs text-white">
                                                Follow-up Lead
                                            </P>
                                        </div>
                                    </div>

                                    <div className="p-1 rounded-sm bg-blue-700 flex items-center justify-between font-vietnam lg:bg-white">
                                        <P className="text-white text-sm lg:text-primary">
                                            Proposal Storage
                                        </P>
                                        <div className="flex justify-between items-center gap-1">
                                            <div className="flex items-center gap-0.5">
                                                <img
                                                    src={statusImages.hot}
                                                    alt="fire"
                                                    className="h-2"
                                                />
                                                <P className="text-sm font-vietnam text-white lg:text-primary">
                                                    {statusData?.hot || 0}
                                                </P>
                                            </div>
                                            <div className="flex items-center gap-0.5">
                                                <img
                                                    src={statusImages.cold}
                                                    alt="cold"
                                                    className="h-2"
                                                />
                                                <P className="text-sm font-vietnam text-white lg:text-primary">
                                                    {statusData?.cold || 0}
                                                </P>
                                            </div>
                                            <div className="flex items-center gap-0.5">
                                                <img
                                                    src={statusImages.mild}
                                                    alt="fire"
                                                    className="h-2"
                                                />
                                                <P className="text-sm font-vietnam text-white lg:text-primary">
                                                    {statusData?.mild || 0}
                                                </P>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Container>
                        </div>
                        <div className="pt-2 rounded-3 bg-white -mt-3 lg:mt-0 lg:pt-0">
                            <Container className="lg:p-1.5  h-full ">
                                <div className="flex items-center mb-1.5 gap-2 border-b border-b-blue-200 ">
                                    <LinedTab
                                        className="pb-0  mt-0 pt-0 w-full "
                                        activeClass={
                                            "text-blue font-medium duration-300 w-[100px]"
                                        }
                                        inActiveClass={
                                            "text-gray-370 w-[100px]"
                                        }
                                        data={["Ongoing", "Completed"]}
                                        activeTab={currentTab}
                                        onClick={handleTabClick}
                                    />
                                    <button
                                        onClick={() =>
                                            setIsOpen((prev) => !prev)
                                        }
                                        className="text-xxl"
                                    >
                                        <IoFilterSharp />
                                    </button>
                                </div>
                                {isOpen && (
                                    <div
                                        className={cn(
                                            "bg-white hidden  lg:block mb-4"
                                        )}
                                    >
                                        <Container>
                                            <CloseButton
                                                onClick={() =>
                                                    setIsOpen((prev) => !prev)
                                                }
                                            />

                                            <Formik
                                                initialValues={filterOptions}
                                                validationSchema={yup
                                                    .object()
                                                    .shape({
                                                        duration: yup.string(),
                                                        assignee: yup.string(),
                                                        plantName: yup.string(),
                                                        plantId: yup.string(),
                                                    })}
                                                onSubmit={handleSubmit}
                                            >
                                                {() => (
                                                    <Form>
                                                        <div className=" pb-8   flex flex-col ">
                                                            <P className="text-primary text-sm font-vietnam mb-2">
                                                                Filter By:
                                                            </P>

                                                            <LabeledFormikSelect
                                                                name="duration"
                                                                label="Date Range"
                                                                options={
                                                                    filterDuration
                                                                }
                                                            />
                                                            {isAdmin && (
                                                                <LabeledFormikSelect
                                                                    name="assignee"
                                                                    label="Assignee Name"
                                                                    options={
                                                                        assignees
                                                                    }
                                                                />
                                                            )}
                                                            <FormikLabeledInput
                                                                name="plantName"
                                                                label="Plant Name"
                                                                placeholder="Enter Plant Name"
                                                            />
                                                            <FormikLabeledInput
                                                                name="plantId"
                                                                label="Plant Id"
                                                                placeholder="Enter Plant Id"
                                                            />
                                                            <Button
                                                                type="submit"
                                                                className="bg-primary"
                                                            >
                                                                Apply Filter
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </Container>
                                    </div>
                                )}

                                <div
                                    className={cn("flex gap-1", {
                                        "pb-1.5":
                                            filterOptions.duration ||
                                            filterOptions.plantId ||
                                            filterOptions.plantName,
                                    })}
                                >
                                    {filterOptions.plantName && (
                                        <button
                                            onClick={() =>
                                                clearFilters("plantName")
                                            }
                                            className={filterButtonStyle}
                                        >
                                            {filterOptions.plantName}
                                            <LiaTimesSolid />
                                        </button>
                                    )}
                                    {filterOptions.duration && (
                                        <button
                                            onClick={() =>
                                                clearFilters("duration")
                                            }
                                            className={filterButtonStyle}
                                        >
                                            {filterOptions.duration}
                                            <LiaTimesSolid />
                                        </button>
                                    )}

                                    {filterOptions.plantId && (
                                        <button
                                            onClick={() =>
                                                clearFilters("plantId")
                                            }
                                            className={filterButtonStyle}
                                        >
                                            {filterOptions.plantId}
                                            <LiaTimesSolid />
                                        </button>
                                    )}
                                </div>
                                {currentTab === 0 && ongoingProject.length
                                    ? ongoingProject.map((project, index) => (
                                          <OngoingStatusCard
                                              onClick={() =>
                                                  setView({
                                                      name: viewsTypes.followup,
                                                      data: {
                                                          followups:
                                                              project?.followups ||
                                                              [],
                                                          meetingNotes:
                                                              project?.freshMeetingNotes ||
                                                              [],
                                                      },
                                                  })
                                              }
                                              key={index}
                                              {...project}
                                          />
                                      ))
                                    : currentTab === 1 &&
                                      completedProject.length
                                    ? completedProject.map((project, index) => (
                                          <CompletedProjectCard
                                              key={index}
                                              onStageClick={(data) =>
                                                  setView({
                                                      name: viewsTypes.stage,
                                                      data: project.plantId,
                                                  })
                                              }
                                              onHistoryClick={(data) =>
                                                  setView({
                                                      name: viewsTypes.history,
                                                      data: data,
                                                  })
                                              }
                                              {...project}
                                          />
                                      ))
                                    : null}
                            </Container>
                        </div>
                    </div>

                    <div className="hidden lg:flex flex-1 lg:flex-col lg:bg-white lg:rounded-2">
                        <div
                            className={cn("mb-0 hidden w-full", {
                                block: view.name === viewsTypes.stage,
                            })}
                        >
                            <AdminProjectStage
                                plantId={view.data}
                                onClick={handleResetView}
                            />
                        </div>

                        <div
                            className={cn("mb-0 hidden", {
                                block: view.name === viewsTypes.followup,
                            })}
                        >
                            <ViewFollowUp
                                data={view.data}
                                onClick={handleResetView}
                            />
                        </div>
                        <div
                            className={cn("mb-0 hidden", {
                                block: view.name === viewsTypes.history,
                            })}
                        >
                            <AdminPaymentReceipt onClick={handleResetView} />
                        </div>
                    </div>
                </div>

                <div className="lg:hidden lg:overflow-hidden lg:w-0 lg:h-0">
                    <BottomDrawer
                        isOpen={isOpen}
                        onClick={() => setIsOpen((prev) => !prev)}
                        contentClass="min-h-[60vh] rounded-t-4 bg-white"
                        childrenClassName="bg-white"
                    >
                        <Container>
                            <Formik
                                initialValues={filterOptions}
                                validationSchema={yup.object().shape({
                                    duration: yup.string(),
                                    assignee: yup.string(),
                                    plantName: yup.string(),
                                    plantId: yup.string(),
                                })}
                                onSubmit={handleSubmit}
                            >
                                {() => (
                                    <Form>
                                        <div className=" pb-8  flex flex-col ">
                                            <P className="text-primary text-sm font-vietnam mb-2">
                                                Filter By:
                                            </P>

                                            <LabeledFormikSelect
                                                name="duration"
                                                label="Date Range"
                                                options={filterDuration}
                                            />
                                            {isAdmin && (
                                                <LabeledFormikSelect
                                                    name="assignee"
                                                    label="Assignee Name"
                                                    options={assignees}
                                                />
                                            )}
                                            <FormikLabeledInput
                                                name="plantName"
                                                label="Plant Name"
                                                placeholder="Enter Plant Name"
                                            />
                                            <FormikLabeledInput
                                                name="plantId"
                                                label="Plant Id"
                                                placeholder="Enter Plant Id"
                                            />
                                            <Button
                                                type="submit"
                                                className="bg-primary"
                                            >
                                                Apply Filter
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Container>
                    </BottomDrawer>
                </div>
            </Section>
        </>
    );
};

export default AdminProjectStatus;

let filterDuration = [
    {
        label: "Today",
        value: "1D",
    },
    {
        label: "7 Days",
        value: "7D",
    },
    {
        label: "30 Days",
        value: "30D",
    },
    {
        label: "1 Year",
        value: "365D",
    },
    {
        label: "Lifetime",
        value: "lifetime",
    },
];
